import { Component, ViewEncapsulation } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
    selector: 'fn-grid-text',
    templateUrl: 'fn-grid-text.component.html',
    styleUrls: ['fn-grid-text.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FnGridTextComponent extends FnGridAbstractCell {
    override changeAction() {
        this.cellValueChange.emit(this.cellValue);
    }

    override blurAction() {
        this.editToggle();
        this.cellBlur.emit(this.cellValue);
    }

    focusAction() {
        this.cellFocus.emit(this.cellValue);
    }
}
